// removed by extract-text-webpack-plugin
module.exports = {"Privacy":"Privacy__Privacy__1-Dj9","Block":"Privacy__Block__24eHt"};


//////////////////
// WEBPACK FOOTER
// ./client/src/containers/Privacy/Privacy.css
// module id = 432
// module chunks = 0